import { Directive, ElementRef, Output, EventEmitter, HostListener, inject } from '@angular/core'

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Output()
  private readonly clickOutside = new EventEmitter<void>()

  private readonly elementRef = inject(ElementRef)

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: PointerEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target)
    if (!clickedInside) {
      this.clickOutside.emit()
    }
  }

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent) {
    event.stopPropagation()
  }
}
